import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "progress-top" }
const _hoisted_2 = { class: "progress-row" }
const _hoisted_3 = { class: "step-label" }
const _hoisted_4 = { class: "step-info" }
const _hoisted_5 = { class: "step-count text-primary" }
const _hoisted_6 = {
  key: 0,
  class: "progress-track"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StepProgressBar',
  props: {
    label: { default: "" },
    percent: { default: null },
    currentStep: {},
    totalSteps: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.label), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, "Step " + _toDisplayString(__props.currentStep) + " of " + _toDisplayString(__props.totalSteps), 1)
      ])
    ]),
    (__props.percent !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "progress-fill",
            style: _normalizeStyle({ width: `${__props.percent}%` })
          }, null, 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})